<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" :to="path">
        <div class="flex flex-direction align-center justify-center logo-box">
          <div>
            <h1 class="sidebar-title">气象</h1>
          </div>
        </div>
      </router-link>
      <router-link v-else key="expand" :to="path">
        <div class="flex flex-direction align-center justify-center logo-box">
          <div>
            <!-- <h1 v-if="logo" class="sidebar-title"></h1> -->
            <h1 class="sidebar-title">{{title}}</h1>
          </div>
        </div>
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: '气象物联网管理系统',
      logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png',
      path:''
    }
  },
  created(){
    this.path = this.$router.options.routes[0].children[0].path
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  // line-height: 50px;
  // background: rgb(48, 65, 86);
  background: #2b2f3a;
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;

  justify-content: center;
  .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
    // .sidebar-subTxt{
    //   font-size: 10px;
    //   font-weight: 600;
    //   color: #fff;
    // }
  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
.logo-box{
  width: 100%;
  height: 100%;
}
</style>
